var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgZoomLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34680_17963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49984 16C12.9183 16 16.5 12.418 16.5 7.99984C16.5 3.58166 12.9183 0 8.49984 0C4.08135 0 0.5 3.58166 0.5 7.99984C0.5 12.418 4.08166 16 8.49984 16Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1945 10.2856H10.4855V6.40586C10.4855 5.82134 10.0118 5.34766 9.42731 5.34766H4.13629V9.22742C4.13629 9.81194 4.60997 10.2856 5.1945 10.2856ZM11.1907 8.875L13.3071 10.2856V5.34766L11.191 6.75859L11.1907 8.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34680_17963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgZoomLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/zoom-logo.e13fe71e7dea26794d62bcf9fe22e1d3.svg";